<template>
    <div class=" no-padding p-t-20 p-b-20 bg-white">
      <div class="container">
        <h1>{{ $t('CandidateEntities.title') }}</h1>

        <h3>{{ $t('CandidateEntities.pending_invitations') }}</h3>
        <div v-if="loading" class="loader">
          <span class="fa fa-spinner fa-spin fa-2x"></span>
        </div>

        <div class="mb-5" v-else>

          <template v-if="hasPendingEntities">
            <entity-candidate-entities-table
              :userEntities="userEntities"
              :withActions="true"
              @delete="onDelete"
              @change="onChange"
            />

            <div class="text-center mt-3">
              <button class="btn btn-pink rounded"
                      type="button"
                      :disabled="validateLoading"
                      @click="onValidate">
                <i class="fa fa-spinner fa-spin" v-if="validateLoading"></i>
                {{ $t('buttons.validate') }}
              </button>
            </div>
          </template>

          <div class="alert alert-secondary mb-5 col-lg-8" role="alert" v-else>
            <p>{{ $t('CandidateEntities.no_pending_invitation') }}</p>
          </div>
        </div>

        <h3>{{ $t('CandidateEntities.profesional_inforamations') }}</h3>
        <template v-if="isSingleEntity">
          <div class="row m-t-40">
            <label class="col-md-3 control-label">{{ $t('models.user.occupations') }}:</label>
            <div class="col-md-9">
              <div class="multiselect__tags-wrap multiselect-show">
                <span
                  v-for="occupation in singleUserEntity.occupations"
                  :key="occupation.id"
                  class="multiselect__tag">
                  <span>{{ occupation.name }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('models.user.internal') }}:</label>
            <div class="col-md-9">
              <p class="text-capitalize">{{ internalLabel }}</p>
            </div>
          </div>
          <div v-if="isInternal" class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('models.user.affiliated_service') }}:</label>
            <div class="col-md-9">
              <services-grouped-by-hubs :services="[singleUserEntity.affiliated_service]"
                                        :hubs="singleUserEntity.entity.hubs"
                                        :shortened="false" />
            </div>
          </div>
          <div class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('models.user.services') }}:</label>
            <div class="col-md-9">
              <services-grouped-by-hubs :services="singleUserEntity.services"
                                        :hubs="singleUserEntity.entity.hubs"
                                        :shortened="false" />
            </div>
          </div>
          <div v-if="currentUser.has_dates_provider" class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('EditProfile.id') }}:</label>
            <div class="col-md-6">
              <span>{{ singleUserEntity.unavailability_dates_provider_id }}</span>
            </div>
          </div>
        </template>

        <user-candidate-entities-table
          v-if="!isSingleEntity && currentUser.user_entities"
          :candidateEntities="activeEntities"
          :isMyEntityPage="true"
        />

        <router-link :to="{ name: 'CandidateJoinEntities' }" class="btn btn-primary m-t-10">
          {{ $t("CandidateEntities.join_new_entity") }}
        </router-link>

      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserCandidateEntitiesTable from '@/components/users/CandidateEntitiesTable';
import EntityCandidateEntitiesTable from '@/components/entities/CandidateEntitiesTable';
import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'
import _ from 'lodash';

export default {
  name: 'CandidateEntities',
  components: {
    UserCandidateEntitiesTable,
    EntityCandidateEntitiesTable,
    ServicesGroupedByHubs
  },
  data() {
    return {
      loading: true,
      validateLoading: false,
      userEntities: []
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    singleUserEntity() {
      let userEntity = this.currentUser.user_entities[0] || {}
      return Object.assign({}, userEntity)
    },
    isInternal() {
      return this.singleUserEntity.resource_type == 'intern'
    },
    internalLabel() {
      return this.isInternal ? this.$t('yes') : this.$t('no')
    },
    isSingleEntity() {
      return this.currentUser.entities && this.currentUser.entities.length == 1
    },
    activeEntities() {
      return this.currentUser.user_entities.filter(ue => ue.aasm_state === 'active')
    },
    hasPendingEntities() {
      return this.userEntities.length > 0;
    }
  },
  async mounted() {
    await this.getCurrentUser()
    this.buildUserEntities()
  },
  methods: {
    ...mapActions({
      getCurrentUser: 'auth/getUser',
      confirmUserEntities: 'users/confirmUserEntities',
      declineUserEntity: 'users/declineUserEntity',
    }),
    buildUserEntities() {
      if (this.loading) {
        this.userEntities = this.getPendingUserEntities();
        this.loading = false;
      }
    },
    getPendingUserEntities() {
      return this.currentUser.user_entities.filter(ue => ue.aasm_state === 'pending');
    },
    userEntityIndex(userEntity) {
      return this.userEntities.findIndex(ue => ue.entity.id === userEntity.entity.id);
    },
    onDelete(userEntity) {
      this.declineUserEntity(userEntity)
        .then(() => {
          this.loading = true
          this.getCurrentUser()
            .then(user => this.buildUserEntities())
            .catch(error => this.loading = false);
        })
    },
    onChange(userEntity) {
      let index = this.userEntityIndex(userEntity);
      let userEntities = _.cloneDeep(this.userEntities);
      userEntities[index] = userEntity;

      this.userEntities = userEntities;
    },
    onValidate() {
      this.validateLoading = true;

      this.confirmUserEntities(this.userEntities)
        .then(response => {
          this.loading = true
          this.getCurrentUser()
            .then(user => this.buildUserEntities())
            .catch(error => this.loading = false);
        })
        .finally(() => {
          this.validateLoading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/CandidateEntities.vue